(function($, App, Utils, Components, Pages) {
  'use strict';

  const logger = new Logger('StaticMaps');

  Pages.create('StaticMaps', {

    Selectors: {
      main: '.js-static-map',
      image: '.js-image-map'
    },

    getMap: () => {
      return $.ajax({
        url: Pages.StaticMaps.data.endpoint,
        type: "POST",
        dataType: "html",
        data: {
          lat: Pages.StaticMaps.data.lat,
          lng: Pages.StaticMaps.data.lng
        }
      });
    },

    init: () => {
      logger.d('StaticMaps init');
      Pages.StaticMaps.data = Utils.jsonDA($(Pages.StaticMaps.Selectors.main), 'staticmap');
      logger.info(Pages.StaticMaps.data);
      Pages.StaticMaps.getMap()
          .then( (res) => {
            $(Pages.StaticMaps.Selectors.main).html(res);
            logger.info(res);
          })
          .catch( (err) => {
            logger.error(err);
          });

    }

  });

})(jQuery,
    window.App,
    window.App.Utils,
    window.App.Components,
    window.App.Pages
);
